// Brand-specific document configuration
// Maps brand identifiers to their respective document file paths

import { detectBrand } from '../utils/brandDetection';
import { BRAND_IDS } from '../config/brands';

export const BRAND_DOCUMENTS = {
  [BRAND_IDS.CLAIM1]: {
    keyFacts: '/files/claims1-mlm-key-facts.md',
    dbaTerms: '/files/claims1-mlm-dba-terms.md',
    mlmFees: '/files/mlm_fees.md',
    termsConditions: '/files/claims1-terms-conditions.md',
    privacyPolicy: '/files/claims1-privacy-policy.md',
    mlmPrivacyPolicy: '/files/mlm-privacy-policy.md',
    representationConsentStatement: '/files/claims1-representation-consent-statement.md'
  },
  [BRAND_IDS.YCM]: {
    keyFacts: '/files/ycm-key-facts.md',
    dbaTerms: '/files/ycm-mlm-dba-terms.md',
    mlmFees: '/files/mlm_fees.md',
    termsConditions: '/files/ycm-terms-conditions.md',
    privacyPolicy: '/files/ycm-privacy-policy.md',
    mlmPrivacyPolicy: '/files/mlm-privacy-policy.md',
    representationConsentStatement: '/files/ycm-representation-consent-statement.md'
  },
  [BRAND_IDS.MLM]: {
    keyFacts: '/files/mlm-key-facts.md',
    dbaTerms: '/files/mlm-dba-terms.md',
    mlmFees: '/files/mlm_fees.md',
    termsConditions: '/files/mlm-dba-terms.md',
    privacyPolicy: '/files/mlm-privacy-policy.md',
    mlmPrivacyPolicy: '/files/mlm-privacy-policy.md',
    representationConsentStatement: '/files/mlm-representation-consent-statement.md'
  }
};

// Helper function to get document path for current brand
// Uses the same brand detection system as the theme provider
export const getDocumentPath = (documentType) => {
  const brand = detectBrand();
  const documents = BRAND_DOCUMENTS[brand.id];
  
  if (!documents || !documents[documentType]) {
    console.warn(`[Brand Documents] Document type "${documentType}" not found for brand "${brand.name}". Falling back to Claims1.`);
    return BRAND_DOCUMENTS[BRAND_IDS.CLAIM1][documentType];
  }
  
  return documents[documentType];
};